import { useCallback, useReducer } from "react";
import { CroppingState } from "./upload.types";

const initialState: CroppingState = {
  file: null,
  highlight: false,
  showCropModal: false,
  selectedImageSrc: null,
  errorMessage: null,
};

export const useCropping = () => {
  const [state, setState] = useReducer(
    (prev: CroppingState, next: Partial<CroppingState>) => ({
      ...prev,
      ...next,
    }),
    initialState,
  );

  const clear = useCallback((inputElement: HTMLInputElement | null) => {
    setState({ file: null, selectedImageSrc: null });

    if (inputElement) {
      inputElement.value = "";
    }
  }, []);

  const onLoad = useCallback((event: ProgressEvent<FileReader>) => {
    setState({ selectedImageSrc: event.target?.result });
  }, []);

  const setFile = useCallback((file: File) => setState({ file }), []);

  const setCropModalVisible = useCallback((visible: boolean) => {
    setState({ showCropModal: visible });
  }, []);

  async function convertBase64ToFile(dataUrl: string): Promise<File> {
    const fileName = `${Math.random().toString(36).slice(-5)}.png`;
    const res: Response = await fetch(dataUrl);
    const blob: Blob = await res.blob();
    return new File([blob], fileName, { type: "image/png" });
  }

  const getCroppedImage = useCallback(async (cropped: string) => {
    const croppedImage = cropped;
    const file = await convertBase64ToFile(croppedImage);

    setState({ file, selectedImageSrc: croppedImage, showCropModal: false });
    return file;
  }, []);

  return {
    state,
    setCropModalVisible,
    getCroppedImage,
    clear,
    onLoad,
    setFile,
  };
};
